import { render, staticRenderFns } from "./Manualcompliance.vue?vue&type=template&id=fa5bdf2e&scoped=true"
import script from "./Manualcompliance.vue?vue&type=script&lang=js"
export * from "./Manualcompliance.vue?vue&type=script&lang=js"
import style0 from "./Manualcompliance.vue?vue&type=style&index=0&id=fa5bdf2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5bdf2e",
  null
  
)

export default component.exports